import { Link } from '~components/Links/Link';
import styled from '@olxui/core/dist/theme/styled';
import { css } from '@emotion/react';

export const StyledLink = styled(Link)<{ disabled?: boolean }>`
    ${({ disabled, theme }) => css`
        background-color: ${disabled
            ? theme.colors['background-brand-disabled']
            : 'inherit'};
        text-decoration: none;
        pointer-events: ${disabled ? 'none' : 'auto'};
        &:link,
        &:visited,
        &:active {
            color: ${disabled
                ? theme.colors['text-global-disabled']
                : theme.colors['$01_white']} !important;
            background-color: ${disabled
                ? theme.colors['background-brand-disabled']
                : theme.colors['borders-brand-primary']};
            border: ${disabled
                ? `5px ${theme.borderStyles.solid} ${theme.colors['background-brand-disabled']}`
                : `5px ${theme.borderStyles.solid} ${theme.colors['borders-brand-primary']}`};
        }
    `}
`;
